import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/users/index.php";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/userModel.js
// module id = 177
// module chunks = 0